const MembershipTypesIndex = () => import('@/views/Dashboard/MembershipTypes/MembershipTypesIndex');
const MembershipTypesAll = () => import('@/views/Dashboard/MembershipTypes/MembershipTypesAll');
const MembershipTypesShowItem = () => import('@/views/Dashboard/MembershipTypes/MembershipTypesShowItem');
const MembershipTypesCreate = () => import('@/views/Dashboard/MembershipTypes/MembershipTypesCreate');
const MembershipTypesEdit = () => import('@/views/Dashboard/MembershipTypes/MembershipTypesEdit');

export default {
  path: '/membership-types',
  component: MembershipTypesIndex,
  children: [
    {
      path: '/',
      name: 'membership-types',
      component: MembershipTypesAll,
      meta: { preserveTableState: true },
    },
    {
      path: 'show/:id',
      name: 'membership-types-show',
      component: MembershipTypesShowItem,
    },
    {
      path: 'create',
      name: 'membership-types-create',
      component: MembershipTypesCreate,
    },
    {
      path: 'edit/:id',
      name: 'membership-types-edit',
      component: MembershipTypesEdit,
    },
  ],
};
